/* parentNameComponent.js */

"use strict";
// const _ = require("lodash");
const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./parentNameRenderer");

class ParentNameComponent extends DefaultColumnComponent {
    constructor(value, context) {
        super(value);
        this._value = value;
        this._context = context;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /* *****************************************
    /* START PUBLIC API METHODS
    /* ***************************************** */
    setValue(newVal) {
        this.setParentName(newVal);
    }

    getValue() {
        return this.getParentName();
    }

    setParentName(newVal) {
        this._value = newVal;
        this.emit("ParentNameChange", newVal);
        return this;
    }

    getParentName() {
        return this._value;
    }

    /* *****************************************
    /* END PUBLIC API METHODS
    /* ***************************************** */
}

module.exports = ParentNameComponent;
